import { apiClient } from "@api/apiClient";

import type { PatentPrimaryCategoryData } from "./patentPrimaryCategory.interface";

const API_ENDPOINT = "/edb/internal/patent/filter/primary-category/";
export const patentPrimaryCategoryApi = {
  getPrimaryCategoryFilterData: async () => {
    const { data } = await apiClient.get<PatentPrimaryCategoryData>(
      API_ENDPOINT,
    );

    return data;
  },
};
